import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Divider, Typography, TextField, MenuItem, Checkbox } from '@mui/material';
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import React, { useReducer, useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const TagsFilter = observer(_ref => {
  let handleClose = _ref.handleClose,
    tagsFilter = _ref.tagsFilter,
    setTagsFilter = _ref.setTagsFilter,
    handleCloseFilter = _ref.handleCloseFilter,
    updateList = _ref.updateList;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchKey = _useState2[0],
    setSearchKey = _useState2[1];
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const _useReducer = useReducer(x => x + 1, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    className: classes.returnFromSecondFilterLevel,
    onClick: event => {
      event.stopPropagation();
      setTagsFilter([]);
      forceUpdate();
      handleCloseFilter();
    },
    'custom-attribute': '660-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down",
    state: "dark"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Filter by tag')), /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    fullWidth: true,
    placeholder: t('general.search'),
    value: searchKey,
    onChange: handleSearchKeyChange
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: classes.filterMultiselectContainer
  }, store.tags.tagsList.map(tag => {
    if (tag.name.toLocaleLowerCase().includes(searchKey.trim().toLocaleLowerCase()) || searchKey.trim() === '') return /*#__PURE__*/React.createElement(MenuItem, {
      key: tag.id,
      value: tag.id,
      variant: "multiple",
      onClick: () => {
        const currentValue = tagsFilter;
        const idx = currentValue.indexOf(tag.id);
        if (idx !== -1) {
          currentValue.splice(idx, 1);
        } else {
          currentValue.push(tag.id);
        }
        setTagsFilter(currentValue);
        forceUpdate();
      },
      'custom-attribute': '661-new-billing-module'
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: tagsFilter.indexOf(tag.id) > -1
    }), tag.name);
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: classes.secondLevelActionBtns
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    className: classes.sortAscOption,
    onClick: event => {
      event.stopPropagation();
      setTagsFilter([]);
      forceUpdate();
      handleCloseFilter();
    },
    'custom-attribute': '662-new-billing-module'
  }, 'Cancel'), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    className: classes.sortAscOption,
    onClick: event => {
      event.stopPropagation();
      forceUpdate();
      handleClose();
      handleCloseFilter();
      updateList();
    },
    'custom-attribute': '663-new-billing-module'
  }, 'Apply')));
});